// extracted by mini-css-extract-plugin
export var galerieContainer = "galerie-images-module--galerie-container--cb0ae";
export var galerieImage = "galerie-images-module--galerie-image--76c51";
export var galerieItemContainer = "galerie-images-module--galerie-item-container--cd6c9";
export var galerieItemDescription = "galerie-images-module--galerie-item-description--244b5";
export var galerieItemHeader = "galerie-images-module--galerie-item-header--1aa0c";
export var galerieItemLink = "galerie-images-module--galerie-item-link--b3857";
export var masonryGrid = "galerie-images-module--masonry-grid--0ef05";
export var masonryGridColumn = "galerie-images-module--masonry-grid-column--76fa8";